import React, { useEffect, useState } from "react";
import AuthentifiedPage from "./AuthentifiedPage";
import { useLocation } from "react-router-dom";
import BackButton from "../components/BackButton";
import { RapportGenere } from "../types/RapportGenere";
import { codeToRapportStatus } from "../utils/rapportStatus";
import { useAuth } from "../context/AuthContext";
import { rapportGenereService } from "../services/RapportGenereService";
import IndicateurTableContainer from "../components/IndicateurTableContainer";
import IndicateurChartContainer from "../components/IndicateurChartContainer";

const RapportDetailPage: React.FC = () => {
  const location = useLocation();
  const [rapport, setRapport] = useState<RapportGenere | null>(null);
  const [indicatorData, setIndicatorData] = useState<Record<number, { meta: any; rows: Record<string, any>[] }>>({});
  const { api } = useAuth();

  useEffect(() => {
    if (location.state?.modele) {
      setRapport(location.state.modele);
      return;
    }
  }, [location.state]);

  useEffect(() => {
    const loadData = async () => {
      if (!rapport || !api) return;

      try {
        const data = await rapportGenereService.getRapportGenereData(api, rapport.idRapportGenere);
        setIndicatorData(data || {});
      } catch (e) {
        console.error("Erreur lors du chargement des données indicateurs:", e);
      }
    };

    loadData();
  }, [rapport, api]);

  if (!rapport) return <AuthentifiedPage><p>Chargement...</p></AuthentifiedPage>;

  return (
    <AuthentifiedPage>
      <div style={{ maxWidth: 900, margin: "20px auto", fontFamily: "Arial" }}>
        <BackButton text="Retour" />
        <h3>Rapport : {rapport.sousFenetre?.nomSousFenetre || rapport.fenetre?.nomFenetre || "-"}</h3>
        <p><strong>Description :</strong> {rapport.rapport.description || "-"}</p>
        <p><strong>Statut :</strong> {codeToRapportStatus(rapport.statut??0)}</p>
        <p><strong>Date de création : </strong>{new Date(rapport.createdAt ?? "").toLocaleString("fr-FR")}</p>

        <hr />

        {/* Indicator overview - reuse the same UI as RapportFromModelePage */}
        <h2 style={{color:"black", width:"fit-content", margin:"2vh auto", marginTop:"5vh", paddingBottom:"1vh", fontWeight:"bold", borderBottom:"1px solid rgba(25,25,25,.2)"}}>Aperçu global</h2>
        <div style={{marginBottom: "5vh"}}>
          <h4 style={{ textAlign:"center" }}>Tableau des indicateurs</h4>
          <IndicateurTableContainer indicatorData={indicatorData}/>
        </div>
        <div style={{marginBottom: "5vh"}}>
          <h4 style={{ margin: "5vh 0" }}>Répartition</h4>
          <IndicateurChartContainer indicatorData={indicatorData} chartType="pie"/>
        </div>

        <div style={{marginBottom: "5vh"}}>
          <h4 style={{ marginTop: "5vh 0" }}>Graphique linéaire</h4>
          <IndicateurChartContainer indicatorData={indicatorData} chartType="area"/>
        </div>
      </div>
    </AuthentifiedPage>
  );
};


export default RapportDetailPage;
